interface IProps {
    width?: number
    height?: number
}

export const RightArrowIcon2 = (props: IProps) => {
    const {width = 21, height = 20} = props;
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 21}
        height={height || 20}
        viewBox="0 0 21 20"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.24419 4.16193L7.06567 5.34044L11.4764 9.75118L7.06567 14.1619L8.24419 15.3404L13.8334 9.75118L8.24419 4.16193Z"
            fill="#FCFCFC"
        />
    </svg>);
}